import React, { Component } from "react";
import Layout from "components/Layout/Layout";
import { Col } from "react-bootstrap";
import SupervisorSummary from "components/supervisor/SupervisorSummary/SupervisorSummary";
import SupervisorLiveStats from "components/supervisor/SupervisorLiveStats/SupervisorLiveStats";
import "./SupervisorDashboard.scss";

export default class SupervisorDashboard extends Component {
  render() {
    return (
      <Layout className="supervisor-dashboard-page">
        <div className="supervisor-dashboard">
          <div className="supervisor-dashboard-content">
            <Col className="supervisor-summary-column" xs="3">
              <SupervisorSummary />
            </Col>
            <Col className="supervisor-live-stats-column" xs="9">
              <SupervisorLiveStats />
            </Col>
          </div>
        </div>
      </Layout>
    );
  }
}
